<template>
  <div>
    <!-- Snackbar -->
    <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Botón para abrir dialog -->
    <div class="my-2">
      <v-btn @click="dialog = true">Check Data</v-btn>
    </div>

    <!-- Dialog para mostrar empresa -->
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          EMPRESA
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialog = false">CLOSE</v-btn>
        </v-card-title>
        <v-card-text class="pprint">
          {{ empresa }}
        </v-card-text>

         <v-card-text class="pprint">
          {{ usuario }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialog = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Contenedor principal -->
    <v-container>
      <v-row>
        <v-col cols="2"></v-col>

        <v-col cols="8">
          <v-card elevation="6">
            <v-card-title class="text-h5">
              Datos de la Empresa
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    
<v-form ref="form" v-model="valid" lazy-validation>


  <v-row>


    <v-col cols="12"  sm="12" md="12"  lg="12">

  <!-- Switch para habilitar edición -->
  <v-switch
    label="Habilitar edición"
    v-model="modoEdicion"
  ></v-switch>


    </v-col>



    <v-col cols="12"  sm="6" md="6"  lg="6">

      
  <v-text-field
    v-model="empresa.tipo_doc"
    label="Tipo de Documento"
    :rules="textRules"
    :disabled="!modoEdicion"
  ></v-text-field>

  <v-text-field
    v-model="empresa.numero_documento"
    label="Número de Documento"
    :rules="textRules"
    :disabled="!modoEdicion"
  ></v-text-field>

  <v-menu
    ref="menuFecha"
    v-model="menuFecha"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="empresa.fecha_nacimiento"
        label="Fecha de Nacimiento"
        readonly
        v-bind="attrs"
        v-on="on"
        :disabled="!modoEdicion"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="empresa.fecha_nacimiento"
      @input="menuFecha = false"
    ></v-date-picker>
  </v-menu>
    
    </v-col>

     <v-col cols="12"  sm="6" md="6"  lg="6">

       <v-text-field
    v-model="empresa.fallecimiento"
    label="Fallecimiento (si aplica)"
    :disabled="!modoEdicion"
  ></v-text-field>

  <v-text-field
    v-model="empresa.nombres"
    label="Nombres"
    :rules="textRules"
    :disabled="!modoEdicion"
  ></v-text-field>

  <v-text-field
    v-model="empresa.apellidos"
    label="Apellidos"
    :rules="textRules"
    :disabled="!modoEdicion"
  ></v-text-field>

  <v-text-field
    v-model="empresa.nombre_fantasia"
    label="Nombre de Fantasía"
    :rules="textRules"
    :disabled="!modoEdicion"
  ></v-text-field>

  <v-text-field
    v-model="empresa.correo_principal"
    label="Correo Principal"
    :rules="emailRules"
    :disabled="!modoEdicion"
  ></v-text-field>

  <v-text-field
    v-model="empresa.correo_secundario"
    label="Correo Secundario (opcional)"
    :rules="emailRules2"
    :disabled="!modoEdicion"
  ></v-text-field>
    
    </v-col>


  </v-row>


 

</v-form>



                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>



<v-card-actions>


  <v-spacer></v-spacer>

  <!-- Botón Cancelar -->
  <v-btn
    outlined
    color="red darken-1"
    text
    @click="cancelarEdicion"
    v-show="modoEdicion"
  >
    <v-icon left>
      mdi-cancel
    </v-icon>
    Cancelar
  </v-btn>

  <!-- Botón Registrar -->
  <v-btn
    outlined
    text
    color="blue darken-4"
    @click="registrarEmpresa();"
    v-show="modoEdicion"
  >
    <v-icon left>
      mdi-content-save-outline
    </v-icon>
    Registrar
  </v-btn>

</v-card-actions>



          </v-card>
        </v-col>

        <v-col cols="2"></v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import usuarioService from "@/services/usuarioService.js";

import empresaService from "@/services/empresaService.js";
import router from '@/router/index';

export default {
  name: 'DatosEmpresa',
  data() {
    return {
        modoEdicion: false, 
 valid: true,
    menuFecha: false,
    empresa: {
      tipo_doc: '',
      numero_documento: '',
      fecha_nacimiento: '',
      fallecimiento: '',
      nombres: '',
      apellidos: '',
      nombre_fantasia: '',
      correo_principal: '',
      correo_secundario: '',
    },

      dialog: false,
      botonDeshabilitado: false,
      btn_nombre: true,
      token: '',
      
      buscador: '',
      showPass: false,
      empresas: [],
      empresa: {
      tipo_doc: '',
      numero_documento: '',
      fecha_nacimiento: '',
      fallecimiento: '',
      nombres: '',
      apellidos: '',
      nombre_fantasia: '',
      correo_principal: '',
      correo_secundario: '',
    },
       usuario:{
      id:'',
      name:'',
      identificador:'',
      email:''
              },
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: 'white',
        timeout: 10000,
      },
      textRules: [
        v => !!v || 'Campo es requerido',
        v => (v && v.length >= 3) || 'Debe contener al menos 3 caracteres',
      ],
      emailRules: [
        v => !!v || 'Correo es requerido',
        v => /.+@.+\..+/.test(v) || 'Correo debe ser válido',
      ],
      emailRules2: [
        v => /.+@.+\..+/.test(v) || 'Correo debe ser válido',
      ],
    };
  },

  mounted() {
   
 

     this.getEmpresa();


  },


  methods: {
    async recaptcha() {
      try {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('login');
        return token;
      } catch (error) {
        console.error('Error al ejecutar reCAPTCHA:', error);
        throw error;
      }
    },

    getEmpresa(){


      empresaService.obtenerEmpresaPorUsuario().then(response =>{



        if(response.data.status){

          this.empresa=response.data.empresa;
          this.usuario=response.data.user;

          console.log('Empresa asociada a usuario encontrada');
        }else{

          

           let iden=localStorage.getItem("identificador");

     this.getUserPorIdentificador(iden);


     console.log('Datos de usuario recuperado.');


        }
           


   }).catch((errors) =>{

          let mensajeError = '';

          mensajeError += "\n"+"Error: "+errors.response.data.message;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
        
           console.log('error');
            console.log(errors);


           
        })

    },


    getUserPorIdentificador:function(identificador){

      usuarioService.obtenerUsuarioPorIdentificador(identificador)
        .then((respuesta) => {

         // console.log(respuesta.data.user);

          this.usuario=respuesta.data.user;


            this.empresa.nombres=respuesta.data.user.name;
     this.empresa.nombre_fantasia=respuesta.data.user.name;
     this.empresa.correo_principal=respuesta.data.user.email;


         
          
        })

},

cancelarEdicion(){

  this.modoEdicion=false;

},

registrarEmpresa(){

  const jsonData = {
  empresa:{...this.empresa}
};

console.log(JSON.stringify(jsonData, null, 2));

  empresaService.save(jsonData).then(response =>{


    this.modoEdicion=false;

      console.log('success');
      console.log(this.empresa);

        let mensajeText = 'Registro exitoso';

             this.mensaje.text=mensajeText;

             this.mensaje.color="primary";
      this.mensaje.colorBtn="blue";

      this.mensaje.snackbar="true";


   }).catch((errors) =>{

          let mensajeError = '';

          mensajeError += "\n"+"Error: "+errors.response.data.message;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
        
           console.log('error');
            console.log(errors);


           
        })

},


   

  },
};
</script>

<style scoped>
.pprint {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
